import React from 'react';
import { Form, TimePicker, Typography, Flex } from 'antd';
import CustomSelect from '../../../components/CustomSelect.js';
import { getFormattedUserTimeZone } from '../../../common/utils/utils.js';

const { Text } = Typography;

interface ScheduleFrequencySelectorProps {
  selectedFrequency: string;
  setSelectedFrequency: (value: string) => void;
}

const scheduleFrequencyOptions = [
  { label: 'Once a day', value: 'ONCE_A_DAY' },
  { label: 'Twice a day', value: 'TWICE_A_DAY' },
  { label: 'Three times a day', value: 'THREE_TIMES_A_DAY' },
];

const ScheduleFrequencySelector: React.FC<ScheduleFrequencySelectorProps> = ({
  selectedFrequency,
  setSelectedFrequency,
}) => {
  const TimezoneNote = () => (
    <Text style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
      {getFormattedUserTimeZone()}
    </Text>
  );

  const getTimeCount = () => {
    if (selectedFrequency === 'ONCE_A_DAY') return 1;
    if (selectedFrequency === 'TWICE_A_DAY') return 2;
    if (selectedFrequency === 'THREE_TIMES_A_DAY') return 3;
    return 0;
  };

  const timeCount = getTimeCount();

  return (
    <>
      <Flex gap={16} align='flex-start'>
        <Form.Item
          className='font-black-color'
          label='Frequency'
          name='frequency'
          style={{ maxWidth: 170, width: '100%' }}
          rules={[{ required: true, message: 'Please select frequency' }]}
        >
          <CustomSelect
            placeholder='Select'
            options={scheduleFrequencyOptions}
            onChange={(val) => setSelectedFrequency(val)}
          />
        </Form.Item>
        {timeCount > 0 && (
          <div style={{ flex: 1 }}>
            <Flex gap={16}>
              {Array.from({ length: timeCount }, (_, idx) => (
                <Form.Item
                  className='font-black-color'
                  key={idx}
                  label='Send at'
                  name={`time_${idx + 1}`}
                  style={{ flex: 1, marginBottom: 0 }}
                  rules={[{ required: true, message: 'Please select time' }]}
                >
                  <TimePicker
                    className='frequency-input'
                    style={{ width: '100%' }}
                    suffixIcon={
                      null
                      // <DownOutlined
                      //   style={{ color: 'var(--text-secondary)', fontSize: '12px' }}
                      // />
                    }
                    use12Hours
                    format='h:mm a'
                  />
                </Form.Item>
              ))}
            </Flex>

            <div style={{ marginTop: 4 }}>
              <TimezoneNote />
            </div>
          </div>
        )}
      </Flex>
    </>
  );
};

export default ScheduleFrequencySelector;
